import { customIdleCallback } from '~/utils/requestIdleCallback'

export const useLoadScript = () => {
  const { create: createScript } = useScriptGenerator()

  const load = (loadScript: LoadScriptArguments, timeout?: number) => {
    customIdleCallback(() => createScript(loadScript), { timeout })
  }

  return { load }
}
